import React from "react";

export default (props) => (
	<section id="recruitments">
		<div className="section_title">
			<p>RECRUITMENTS</p>
			<h2>募集職種</h2>
		</div>
		<div className="section_contents">
			<div className="job_list">
				<div className="job_item">
					<a
						className="job_item_link"
						onClick={props.toRecruit}
						data-id="director"
					>
						<h3 className="title">Webディレクター</h3>
						<p className="text">
							自分のコンサル力、試してみませんか？
						</p>
						<ul className="job_tag_list">
							<li className="_new">新卒採用</li>
							<li className="_mid">中途採用</li>
							<li>Webディレクション</li>
							<li>Webマーケティング</li>
							<li>Webコンサルティング</li>
							<li>提案営業</li>
						</ul>
					</a>
				</div>
				<div className="job_item">
					<a
						className="job_item_link"
						onClick={props.toRecruit}
						data-id="backend"
					>
						<h3 className="title">Webエンジニア</h3>
						<p className="text">最新技術を駆使したWebサイト構築</p>
						<ul className="job_tag_list">
							<li className="_new">新卒採用</li>
							<li className="_mid">中途採用</li>
							<li>Sitecoreサイト構築</li>
							<li>Sitecore機能拡張</li>
							<li>Webアプリ開発</li>
						</ul>
					</a>
				</div>
				<div className="job_item">
					<a
						className="job_item_link"
						onClick={props.toRecruit}
						data-id="designer"
					>
						<h3 className="title">Webデザイナー</h3>
						<p className="text">心を動かすデザインでゴールへ導く</p>
						<ul className="job_tag_list">
							<li className="_new">新卒採用</li>
							{/* <li className="_mid">中途採用</li> */}
							<li>Webデザイン制作</li>
							<li>コーディング</li>
						</ul>
					</a>
				</div>
				<div className="job_item">
					<a
						className="job_item_link"
						onClick={props.toRecruit}
						data-id="sales"
					>
						<h3 className="title">企画提案営業</h3>
						<p className="text">
							アイデアと提案力で大手企業を動かす
						</p>
						<ul className="job_tag_list">
							<li className="_new">新卒採用</li>
							<li className="_mid">中途採用</li>
							<li>企画提案営業</li>
							<li>協業推進・情報発信</li>
							<li>イベント・セミナーの企画・運営</li>
						</ul>
					</a>
				</div>
				{/* <div className="job_item">
          <a className="job_item_link" onClick={props.toRecruit} data-id="accounting">
            <h3 className="title">経営企画室</h3>
            <p className="text">普通の事務職とは一味違います</p>
            <ul className="job_tag_list">
              <li className="_new">新卒採用</li>
              <li>総務</li>
              <li>労務</li>
              <li>経理</li>
              <li>人事</li>
              <li>社内企画立案</li>
            </ul>
          </a>
        </div> */}
				{/* <div className="job_item">
          <a className="job_item_link" onClick={props.toRecruit} data-id="video">
            <h3 className="title">動画クリエイター</h3>
            <p className="text">映像の力で最高のブランディングを</p>
            <ul className="job_tag_list">
              <li className="_mid">中途採用</li>
              <li>動画コンテンツ企画・作成</li>
              <li>動画コンテンツディレクション</li>
            </ul>
          </a>
        </div> */}
				{/* <div className="job_item">
          <a className="job_item_link" onClick={props.toRecruit } data-id="infra">
            <h3 className="title">インフラエンジニア</h3>
            <p className="text">Webサイトを支えるインフラ構築</p>
            <ul className="job_tag_list">
              <li className="_mid">中途採用</li>
              <li>Webサイトのインフラ設計</li>
              <li>Webサイトのインフラ運用</li>
            </ul>
          </a>
        </div>
        <div className="job_item">
          <a className="job_item_link" onClick={props.toRecruit } data-id="frontend">
            <h3 className="title">フロントエンドエンジニア</h3>
            <p className="text"></p>
            <ul className="job_tag_list">
              <li className="_mid">中途採用</li>
              <li>あああああ</li>
              <li>あああああ</li>
            </ul>
          </a>
        </div> */}
			</div>
		</div>
	</section>
);



// WEBPACK FOOTER //
// ./src/Home/Recruitments.js